import {
  GET_PAYSLIP_OVERVIEW,
  GET_PAYSLIP_YEAR,
  GET_PAYSLIP_DETAIL,
  GET_FILE_PAYSLIP_DETAIL,
  SET_PAYSLIP_OVERVIEW,
  SET_PAYSLIP_YEAR,
  SET_PAYSLIP_DETAIL,
  EXPORT_PAYSLIP_DETAIL,
} from './constants';

export const getPayslipYear = (payload) => ({
  type: GET_PAYSLIP_YEAR,
  payload,
});

export const setPayslipYear = (payload) => ({
  type: SET_PAYSLIP_YEAR,
  payload,
});

export const getPayslipOverview = (payload) => ({
  type: GET_PAYSLIP_OVERVIEW,
  payload,
});

export const setPayslipOverview = (payload) => ({
  type: SET_PAYSLIP_OVERVIEW,
  payload,
});

export const getPayslipDetail = (payload, callback) => ({
  type: GET_PAYSLIP_DETAIL,
  payload,
  callback,
});

export const setPayslipDetail = (payload) => ({
  type: SET_PAYSLIP_DETAIL,
  payload,
});

export const getFilePayslipDetail = (payload) => ({
  type: GET_FILE_PAYSLIP_DETAIL,
  payload,
});

export const exportPayslipDetail = (payload) => ({
  type: EXPORT_PAYSLIP_DETAIL,
  payload,
});
